﻿'use strict';

angular.module('ntmApp').factory('FormValidator', ['ListGridHelper', 'ListGridStatus', function (ListGridHelper, ListGridStatus) {

    var validator = {};
    var filloutFieldMsg = "Please, fill out all required fields.";

    validator.validate = function (form, model, actionType, fields) {

        var validationInfo = new ValidationInfo();

        if (form && !form.$valid && (!form.$error.time || form.$error.time && Object.keys(form.$error).length > 1)) {
            validationInfo.setError(filloutFieldMsg);
            return validationInfo;
        }

        ListGridStatus.columns.forEach(function (column) {

            var field = (fields || []).filter(f => f.key === column.fieldName)[0] || {};
            
            if (column.isHide || field.hide) {
                return;
            }

            if (!form && column.required && (!model[column.fieldName])) {
                validationInfo.setError(filloutFieldMsg);
            }

            if (column.type === 'AUTOCOMPLETE') {
                var pkColumn = ListGridHelper.getColumnByFieldName(column.propertyObj.key);
                var modelId = model[column.propertyObj.key] || model[pkColumn.name];

                if (column.required && !modelId) {
                    var modelValue = model[column.name] ? model[column.name] : model[column.fieldName];
                    validationInfo.setError(buildInvalidDataMessage(modelValue, column.name));                    
                }
                if (!column.protect && !(column.editProtect && actionType === 1)) {
                    var contains = model['options_' + column.attributeId]
                    .filter(function (item) { return item[column.fieldName] === model[column.fieldName]; });

                    if (contains && contains.length === 0) {

                        validationInfo.setError(buildInvalidDataMessage(model[column.fieldName], column.name));
                    }
                }
                
            }

            if (column.type === 'CHECKBOXLIST' && column.required) {
                var btn = '.' + column.name + ' button';
                if ($(btn)[0]) {
                    if (!model[column.name] || model[column.name].length === 0) {
                        validationInfo.setError(filloutFieldMsg);
                        $(btn)[0].style.border = '1px dashed #a94442';
                    } else {
                        $(btn)[0].style.border = '';
                    }
                }
                else {
                    btn = '.' + column.fieldName + ' button';
                    if ($(btn)[0]) {
                        if (!model[column.fieldName] || model[column.fieldName].length === 0) {
                            validationInfo.setError(filloutFieldMsg);
                            $(btn)[0].style.border = '1px dashed #a94442';
                        } else {
                            $(btn)[0].style.border = '';
                        }
                    }
                }
            }
        });

        return validationInfo;
    };

    function buildInvalidDataMessage(propertyValue, propertyName) {
        return "{0}'{1}' does not exist. Please, enter valid value.".format(propertyName.replaceAll('_',' '), propertyValue);
    }

    function ValidationInfo(message) {

        var errorMessage = message;

        this.setError = function (error) {
            errorMessage = error;
        };

        this.getError = function () {
            return errorMessage;
        };

        this.isValid = function () {
            return !errorMessage;
        };
    }

    return validator;    
}]);